export default angular
  .module('app.session')
  .factory('HoldingSession', HoldingSession)
  .name;

function HoldingSession() {
  'ngInject';

  let sessionId = null;

  return {
    clearSessionId,
    getSessionId,
    setSessionId,
  };

  function clearSessionId() {
    sessionId = null;
  }

  function getSessionId() {
    return sessionId;
  }

  function setSessionId(newSessionId) {
    sessionId = newSessionId;
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/session/services/session.js